import React, { useEffect } from 'react';
import { AppLayout } from '../../AppLayout';
import { useNavigate, useParams } from 'react-router-dom';
import { AppLanguage } from '../../model/enums/AppLanguage';
import { useTranslation } from 'react-i18next';

const isValidLanguage = (lang: string): lang is AppLanguage => {
  return Object.values(AppLanguage).some((appLanguage) => appLanguage === lang);
};

export const LocalizedRoute = (props: { children: React.ReactNode }) => {
  // Routes come in two flavours: the unprefixed default ones ('/', '/poradenstvi')
  // and the language prefixed ones ('/en', '/en/poradenstvi'). Only the latter
  // carry a lang param, and only that param may switch the language.
  const { lang } = useParams();
  const navigate = useNavigate();
  const { i18n } = useTranslation();

  useEffect(() => {
    if (lang === undefined) {
      return;
    }
    if (isValidLanguage(lang)) {
      i18n.changeLanguage(lang);
    } else {
      navigate('/', { replace: true });
    }
  }, [lang]);

  return <AppLayout>{props.children}</AppLayout>;
};
